import type { ComponentProps } from "react";
import { cn } from "@acdc2/ui/lib/utils";
import { mdiDrag } from "@mdi/js";
import { Icon } from "@mdi/react";

type Props = ComponentProps<"div">;

export function RegionDraggable({ className, ...props }: Props) {
  return (
    <div
      className={cn("hover:bg-black/5 p-1 rounded cursor-grab", className)}
      {...props}
    >
      <Icon path={mdiDrag} size="1.25rem" />
    </div>
  );
}
